/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useLoadingContext } from '../providers/PackagePickerLoadingProvider';
export const useQueriesHandler = _ref => {
  var _allQueries$find;
  let {
    callbacks: componentCallbacks,
    queries,
    componentName
  } = _ref;
  const context = useLoadingContext();
  const [loaded, setLoaded] = React.useState(false);
  const allQueries = Object.values(queries);
  const isLoading = allQueries.some(q => q == null ? void 0 : q.isLoading);
  const isError = allQueries.some(q => q == null ? void 0 : q.isError);
  const isSuccess = allQueries.every(q => q == null ? void 0 : q.isSuccess);
  const data = {};
  Object.entries(queries).forEach(_ref2 => {
    let [queryName, query] = _ref2;
    data[queryName.replace('Query', 'Data')] = query.data;
  });
  const error = (_allQueries$find = allQueries.find(q => q == null ? void 0 : q.error)) == null ? void 0 : _allQueries$find.error;
  React.useEffect(() => {
    if (!isSuccess) {
      context.onInit == null || context.onInit({
        componentName
      });
      componentCallbacks.onInit == null || componentCallbacks.onInit({
        componentName
      });
    }
  }, []);
  React.useEffect(() => {
    if (!isLoading && !loaded) {
      const loadData = {
        componentName,
        ...data
      };
      setLoaded(true);
      context.onLoad == null || context.onLoad(loadData);
      componentCallbacks.onLoad == null || componentCallbacks.onLoad(loadData);
    }
  }, [isLoading]);
  React.useEffect(() => {
    const errorData = {
      componentName,
      error
    };
    if (isError) {
      context.onError == null || context.onError(errorData);
      componentCallbacks.onError == null || componentCallbacks.onError(errorData);
    }
  }, [isError]);
  return {
    isLoading,
    isError,
    data,
    error,
    isSuccess
  };
};
//# sourceMappingURL=useQueriesHandler.js.map